import React, { FunctionComponent } from 'react';
import { EmptyLayout } from '../components/layout/EmptyLayout';
import MaydayLogo from '../assets/icons/mayday.svg';

export const ErrorPage: FunctionComponent = () => {
  return (
    <>
      <div className="fixed t-0 l-0 r-0 w-full md:h-header-bar bg-blue p-lg mb-xxl">
        <a href="https://getmayday.com" className="flex items-center">
          <MaydayLogo className="inline-block mr-lg w-logo-small h-logo-small md:w-logo-normal md:h-logo-normal" />
          <span className="text-white text-xxl md:text-xxxl font-medium">
            Mayday
          </span>
        </a>
      </div>
      <div className="container pt-header-bar-small px-lg md:px-0 md:pt-header-bar w-full md:mx-auto h-full md:w-wide-public-container">
        <div className="mt-xl">
          <EmptyLayout>
            <h1 className="text-xxl mb-md">Oops!</h1>
            <p className="mb-sm">
              An error occurred. Sorry about that! Our engineers have been
              notified.
            </p>
            <p>
              If you continue to experience problems, please use the chat bot in
              the bottom right-hand corner.
            </p>
          </EmptyLayout>
        </div>
      </div>
    </>
  );
};
